<div class="loading-wrapper" [class.full-screen-wrapper]="isFullScreen" [class.show-bg]="showBg()">
  <div class="dot-flashing"></div>
</div>
